import React, { useState, useEffect } from 'react';
import { updateCommunity, deleteCommunity, createFormData } from '../../ajax_utils';
import { flashForReact } from '../../flash_react';
import PreviewDropzone from '../preview_dropzone';

const Overview = ({ show, community, setCommunity }) => {
  const [name, setName] = useState(community.name);
  const [industries, setIndustries] = useState(community.industries);
  const [description, setDescription] = useState(community.description);
  const [rules, setRules] = useState(community.rules);
  const [errors, setErrors] = useState('');
  const [files, setFiles] = useState([]);
  const [imgUrl, setImgUrl] = useState(community.image_url);
  const [openForSponsorship, setopenForSponsorship] = useState(community.open_for_sponsorship);
  const [params, setParams] = useState(null);

  useEffect(() => {
    setParams({
      name,
      industries,
      description,
      rules,
      files,
      openForSponsorship
    });
  }, [name, description, industries, rules, files, openForSponsorship]);

  useEffect(() => {
    setImgUrl(community.image_url);
  }, [imgUrl]);

  const handleUpdate = (
    params,
    successCallback,
    errorCallback,
  ) => {
    const formData = createFormData(params, files);

    updateCommunity(
      community,
      params,
      successCallback,
      errorCallback,
      formData
    );
  };

  const handleChange = (e, callback) => {
    e.preventDefault();
    callback(e.target.value);
  };

  const handleDelete = (
    successCallback,
    errorCallback,
  ) => {
    deleteCommunity(
      community,
      successCallback,
      errorCallback,
    );
  }

  const handleDeleteSuccess = (res) => {
    flashForReact('notice', 'Managed to delete community. You will be redirected');
    setErrors('');
    setTimeout(function(){
      window.location.href = '/';
    }, 2000);
  };

  const handleDeleteErrors = (err) => {
    flashForReact('danger', err.responseJSON.errors);
    setErrors(err.errors);
  };

  const handleApiSuccess = (res) => {
    setCommunity(res.success);
    flashForReact('notice', res.message);
    setErrors('');
  };

  const handleApiErrors = (err) => {
    setErrors(err.errors);
  };

  const handleApiFail = (err) => {
    flashForReact('danger', err.responseJSON.errors);
  };

  return (
    show && (
      <div className='community-settings' id='overview'>
        <div className='h2 mb-4 mt-n2'>Overview</div>
        <div className='form-group col-md-8'>
          <label className='mb-3' htmlFor='community_name'>
            Name
          </label>
          <input
            type='text'
            className='form-control'
            name='community[name]'
            id='community_name'
            placeholder='Enter your community name here'
            value={name}
            onChange={(e) => handleChange(e, setName)}
          />
        </div>
        <label className='mb-3' htmlFor='community_name'>
          Community Profile Photo
        </label>
        <PreviewDropzone files={files} setFiles={setFiles} imgUrl={imgUrl} />
        <div className='form-group col-md-8'>
          <label className='mb-3' htmlFor='community_industries'>
            Industries
          </label>
          <input
            type='text'
            className='fs-4 form-control'
            placeholder='Comma separate industries here'
            value={industries}
            onChange={(e) => handleChange(e, setIndustries)}
          />
        </div>
        <div className='form-group col-md-8'>
          <label className='mb-3' htmlFor='community_description'>
            Description
          </label>
          <textarea
            className='fs-4 form-control'
            rows='6'
            id='community_description'
            placeholder='Briefly describe your community'
            value={description}
            onChange={(e) => handleChange(e, setDescription)}
          />
        </div>
        <div className='mb-6 col-md-8'>
          <label className='mb-3' htmlFor='community_Rules & Expectations'>
            Rules & Expectations
          </label>
          <textarea
            name='textarea'
            className='fs-4 form-control'
            rows='6'
            id='community_rules'
            placeholder='Establish some ground rules'
            value={rules}
            onChange={(e) => handleChange(e, setRules)}
          />
        </div>
        <label className='mb-3' htmlFor='community_discoverability'>
          Open for sponsorship
        </label>
        <div className='col-md-4 d-md-flex justify-content-between mb-6'>
          <div className='col-md-5 mb-2 mb-md-0'>
            <input
              type='radio'
              className='btn-check'
              name='options'
              id='btn-check-1-outlined'
              defaultChecked={openForSponsorship}
              autoComplete='off'
            />
            <label
              className='btn btn-outline-primary w-100 admin-btn-lg'
              htmlFor='btn-check-1-outlined'
              onClick={() => setopenForSponsorship(true)}
            >
              Yes
            </label>
          </div>
          <div className='col-md-5'>
            <input
              type='radio'
              className='btn-check'
              name='options'
              id='btn-check-2-outlined'
              autoComplete='off'
              defaultChecked={!openForSponsorship}
            />
            <label
              className='btn btn-outline-primary w-100 admin-btn-lg'
              htmlFor='btn-check-2-outlined'
              onClick={() => setopenForSponsorship(false)}
            >
              No
            </label>
          </div>
        </div>
        <button
          className='btn btn-primary btn-lg col-md-3 col-12 update-btn mb-md-12'
          onClick={() =>
            handleUpdate(
              params,
              handleApiSuccess,
              handleApiErrors
            )
          }
        >
          Update Settings
        </button>
        <button
          className='btn btn-primary btn-sm col-md-3 col-12 cancel-btn mb-md-12'
          onClick={() => {
            if(!window.confirm('Are you sure you want to do this!?'))
              return;
            if(!window.confirm('There is no way to restore it!'))
              return;

            handleDelete(
              handleDeleteSuccess,
              handleDeleteErrors
            )
          }}>
          Delete Community
        </button>
      </div>
    )
  );
};

export default Overview;
